import HomePage from './components/HomePage.js';

import ComponentPage from './components/ComponentPage.js';

import BottomBarProTargetingDefaultProps from './components/BottomBarProTargeting.defaultProps.json';
import BottomBarProRSSFeedDefaultProps from './components/BottomBarProRSSFeed.defaultProps.json';
import BottomBarExpandableDefaultProps from './components/BottomBarExpandable.defaultProps.json';
import OverlayHomeStretchDefaultProps from './components/OverlayHomeStretch.defaultProps.json';
import OverlayApplicationProProps from './components/OverlayApplicationPro.defaultProps.json';
import OverlayMadMoneyCramerProps from './components/OverlayMadMoneyCramer.defaultProps.json';
import OverlayCramerInvestingGuideProps from './components/OverlayCramerInvestingGuide.defaultProps.json';
import OverlayApplicationProRssProps from './components/OverlayApplicationProRss.defaultProps.json';
import OverlayProPersonalFinanceProps from './components/OverlayProPersonalFinance.defaultProps.json';
import OverlayProNewsProps from './components/OverlayProNews.defaultProps.json';
import InlineWarrenBuffetProps from './components/InlineWarrenBuffet.defaultProps.json';

import TestPage from './components/TestPage.js';
import PrettyPrintJsonPage from './components/PrettyPrintJsonPage.js';
import StatusPage from './components/StatusPage.js';

const routes = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/components/BottomBarProTargeting.json',
    element: <PrettyPrintJsonPage data={BottomBarProTargetingDefaultProps} />,
  },
  {
    path: '/components/BottomBarProRSSFeed.json',
    element: <PrettyPrintJsonPage data={BottomBarProRSSFeedDefaultProps} />,
  },
  {
    path: '/components/BottomBarExpandable.json',
    element: <PrettyPrintJsonPage data={BottomBarExpandableDefaultProps} />,
  },
  {
    path: '/components/OverlayHomeStretch.json',
    element: <PrettyPrintJsonPage data={OverlayHomeStretchDefaultProps} />,
  },

  {
    path: '/components/OverlayApplicationPro.json',
    element: <PrettyPrintJsonPage data={OverlayApplicationProProps} />,
  },
  {
    path: '/components/OverlayMadMoneyCramer.json',
    element: <PrettyPrintJsonPage data={OverlayMadMoneyCramerProps} />,
  },
  {
    path: '/components/OverlayCramerInvestingGuide.json',
    element: <PrettyPrintJsonPage data={OverlayCramerInvestingGuideProps} />,
  },
  {
    path: '/components/OverlayApplicationProRss.json',
    element: <PrettyPrintJsonPage data={OverlayApplicationProRssProps} />,
  },
  {
    path: '/components/OverlayProPersonalFinance.json',
    element: <PrettyPrintJsonPage data={OverlayProPersonalFinanceProps} />,
  },
  {
    path: '/components/OverlayProNews.json',
    element: <PrettyPrintJsonPage data={OverlayProNewsProps} />,
  },
  {
    path: '/components/InlineWarrenBuffet.json',
    element: <PrettyPrintJsonPage data={InlineWarrenBuffetProps} />,
  },
  {
    path: '/components/:componentName',
    element: <ComponentPage />,
  },
  {
    path: '/test/:componentName',
    element: <TestPage />,
  },
  {
    path: '/status',
    element: <StatusPage />,
  },
];

export default routes;
